/* eslint no-cond-assign: 0 */
import {
    put,
    select
} from 'redux-saga/effects';

import {
    saveRequestSwatchSelections
} from '../actions/productActions';

import { buildSwatchString } from '../utils/requestSwatchUtils';

/**
 * Pre-select swatch corresponding to product's currently selected color.
 * Checks for userInitiatedSelection flag to avoid hijacking user intent.
 * @return {undefined}
 */
export function *selectInitialSwatchSaga() {
	let state = yield select();
    const { selectedCount = 0, swatches = [], userInitiatedSelection = false } =
        _.get(state, 'product.productRequestSwatch', {});

    if (userInitiatedSelection || selectedCount > 0) {
        return;
    }

    const { colorCode } = _.get(state, 'product.productRequestSwatch.selectedColorCode');

    if (!colorCode) {
        return;
    }

    const swatch = _.find(swatches, { colorCode });

    if (swatch) {
        const selectedProduct = _.get(state, 'product.productRequestSwatch.selectedProduct', {});
        yield put(saveRequestSwatchSelections(
            [swatch],
            1,
            buildSwatchString(
                selectedProduct.styleNumber,
                '', // No way to infer material name, see UW-24959
                swatch
            )
        ));
    }
}
